/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/jsx-props-no-spreading */
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory, withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import AuditCountInstance from '../../components/AuditCountInstance/AuditCountInstance.component';
import CountInstanceSingle from '../../components/CountInstanceSingle/CountInstanceSingle.component';
import ErpCountInstance from '../../components/ErpCountInstance/ErpCountInstance.component';
import WithSpinner from '../../components/WithSpinner/WithSpinner.HOC';
import { DEFAULT_LIMIT_START, DEFAULT_OFFSET_START } from '../../constants';
import { searchAuditCountInstanceStartAsync } from '../../redux/CountInstanceDetails/AuditCount/AuditCount.action';
import {
	selectAuditCountInstanceError,
	selectIsAuditCountInstanceLoaded,
} from '../../redux/CountInstanceDetails/AuditCount/AuditCount.selector';
import { fetchCountInstanceStartAsync } from '../../redux/CountInstanceDetails/CountInstanceSingle/CountInstanceSingle.actions';
import {
	selectCountInstanceError,
	selectIsCountInstanceLoaded
} from '../../redux/CountInstanceDetails/CountInstanceSingle/CountInstanceSingle.selector';
import { searchERPCountInstanceStartAsync } from '../../redux/CountInstanceDetails/ErpCount/ErpCount.action';
import {
	selectErpCountInstanceError,
	selectIsErpCountInstanceLoaded,
} from '../../redux/CountInstanceDetails/ErpCount/ErpCount.selector';

const CountInstanceSingleWithSpinner = WithSpinner(CountInstanceSingle);
const ErpCountInstanceWithSpinner = WithSpinner(ErpCountInstance);
const AuditCountInstanceWithSpinner = WithSpinner(AuditCountInstance);

function CountInstanceContainer({
	fetchErpCountStart,
	fetchAuditCountStart,
	fetchCountInstanceStart,
	isErpCountLoaded,
	isAuditCountLoaded,
	isCountInstanceLoaded,
	errorErpFetchMessage,
	errorAuditFetchMessage,
	errorCountInstanceMessage,
	...otherProps
}) {

	const history = useHistory()

	const {year} = Object.fromEntries(
		new URLSearchParams(window.location.search).entries(),
	);

	useEffect(() => {
		const url = new URL(window.location)
			if (!url.searchParams.has('year')) {
			const currentYear = new Date().getFullYear();
			url.searchParams.set("year" , currentYear);
			history.replace({search: url.search})
	}
	},[history])

	useEffect(() => {
		if(year)
		{
		fetchAuditCountStart(otherProps.match.params.uuid,year);
		fetchErpCountStart(otherProps.match.params.uuid, year);
		fetchCountInstanceStart(otherProps.match.params.uuid, year);
		}
	}, [year]);
	return (
		<div className="py-5 overflow-x-scroll">
			{errorCountInstanceMessage == null ? (
				<CountInstanceSingleWithSpinner
					isLoaded={isCountInstanceLoaded}
					{...otherProps}
				/>
			) : (
				<CountInstanceSingleWithSpinner
					isLoaded={!isCountInstanceLoaded}
					{...otherProps}
				/>
			)}
			<div className="grid sm:grid-cols-1 xs:grid-cols-1 md:grid-cols-2 lg:grid-cols-2  overflow-x-scroll">
				{errorErpFetchMessage == null ? (
					<ErpCountInstanceWithSpinner
					  year={year}
						isLoaded={isErpCountLoaded}
						{...otherProps}
					/>
				) : (
					<ErpCountInstanceWithSpinner
					  year={year}
						isLoaded={!isErpCountLoaded}
						{...otherProps}
					/>
				)}

				{errorAuditFetchMessage == null ? (
					<AuditCountInstanceWithSpinner
					  year={year}
						isLoaded={isAuditCountLoaded}
						{...otherProps}
					/>
				) : (
					<AuditCountInstanceWithSpinner
					  year={year}
						isLoaded={!isAuditCountLoaded}
						{...otherProps}
					/>
				)}
			</div>
		</div>
	);
}

const mapStateToProps = createStructuredSelector({
	isErpCountLoaded: selectIsErpCountInstanceLoaded,
	isAuditCountLoaded: selectIsAuditCountInstanceLoaded,
	isCountInstanceLoaded: selectIsCountInstanceLoaded,
	errorErpFetchMessage: selectErpCountInstanceError,
	errorAuditFetchMessage: selectAuditCountInstanceError,
	errorCountInstanceMessage: selectCountInstanceError,
});
const mapDispatchToProps = dispatch => ({
	fetchAuditCountStart: (id, year) =>
		dispatch(
			searchAuditCountInstanceStartAsync(
				id,
				DEFAULT_OFFSET_START,
				DEFAULT_LIMIT_START,
				year,
			),
		),
	fetchErpCountStart: (id, year) =>
		dispatch(
			searchERPCountInstanceStartAsync(
				id,
				DEFAULT_OFFSET_START,
				DEFAULT_LIMIT_START,
				'',
				year
			),
		),
	fetchCountInstanceStart: (id,year)  => dispatch(fetchCountInstanceStartAsync(id ,year)),
});
export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(withRouter(CountInstanceContainer));
